import React, { lazy } from "react";
import { DetailsSections } from "../../@types/enums/details-sections/DetailsSections";
import { Loader } from "../root/loader";
const Details = lazy(() => import("./components/details"));

export const details = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details",
            element: (
                <Loader>
                    <Details section={DetailsSections.Registry} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/registry",
            element: (
                <Loader>
                    <Details section={DetailsSections.Registry} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/business",
            element: (
                <Loader>
                    <Details section={DetailsSections.Business} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/offices",
            element: (
                <Loader>
                    <Details section={DetailsSections.Offices} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/accounting",
            element: (
                <Loader>
                    <Details section={DetailsSections.Accounting} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/antimoneylaundering",
            element: (
                <Loader>
                    <Details section={DetailsSections.AntimoneyLaundering} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/intrastat",
            element: (
                <Loader>
                    <Details section={DetailsSections.Intrastat} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/creditlines",
            element: (
                <Loader>
                    <Details section={DetailsSections.Banks} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/${DetailsSections.Registry}`,
            element: (
                <Loader>
                    <Details section={DetailsSections.Registry} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/${DetailsSections.Offices}`,
            element: (
                <Loader>
                    <Details section={DetailsSections.Offices} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/${DetailsSections.Accounting}`,
            element: (
                <Loader>
                    <Details section={DetailsSections.Accounting} />{" "}
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/${DetailsSections.AntimoneyLaundering}`,
            element: (
                <Loader>
                    <Details section={DetailsSections.AntimoneyLaundering} />{" "}
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/${DetailsSections.Intrastat}`,
            element: (
                <Loader>
                    <Details section={DetailsSections.Intrastat} />{" "}
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/${DetailsSections.Business}`,
            element: (
                <Loader>
                    <Details section={DetailsSections.Business} />{" "}
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/${DetailsSections.Banks}`,
            element: (
                <Loader>
                    <Details section={DetailsSections.Banks} />{" "}
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/${DetailsSections.Intermediaries}`,
            element: (
                <Loader>
                    <Details section={DetailsSections.Intermediaries} />{" "}
                </Loader>
            )
        }
    }
];
